<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    ref="frame"
    class="popup-wrapper">
    <div class="flex flex-col popup-background" tabindex="1">
      <div class="send-reminder-cont">
        <p v-if="!use_saved_card">Please enter your <strong>Card </strong> details to proceed. </p>
        <div v-if="pi_secret">
          <div v-if="showCard">
            <stripe-vue-card ref="paymentBridge"
                             :pi_secret="pi_secret"
                             :seti="seti"
                             :info="{payAmount: 0}"/>
            <div class="form-agreement">
              <div class="flex flex-col">
                <div class="flex">
                  <input type="checkbox" v-model="check"/>
                  <div class="flex flex-col">
                    <h5 class="aggrement-label pl-2">Set as default</h5>
                    <span class="agreement-desc"><i>*We don't store your actual card information</i></span>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div v-else>
            <div class="flex justify-center">
              <i class="fas fa-check" />
              <span>Payment Successful</span>
            </div>
          </div>
        </div>
        <div v-else-if="!use_saved_card || loading">
          <div class="loading mt-2 relative">
            <div class="effect-1 effects"></div>
            <div class="effect-2 effects"></div>
            <div class="effect-3 effects"></div>
          </div>
        </div>
      </div>
      <div v-if="!loading">
        <div class="w-full mt-4" v-if="pi_secret && !use_saved_card">
          <div class="popup-button positive" @click="confirm">Confirm</div>
          <div class="popup-button negative" @click="cancel">Cancel</div>
        </div>
        <div class="w-full mt-4" v-else-if="payment_completed">
          <div class="popup-button positive" @click="confirm_payment_complete">Ok</div>
        </div>
        <div class="w-full mt-4" v-else>
          <button class="popup-button positive" @click="pay_with_saved">Confirm</button>
          <button class="popup-button negative" @click="cancel">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import StripeVueCard from '../../../components/stripe/StripeVueCard'
export default {
  props: {
    updated: {
      type: Function
    },
    cancel: {
      type: Function
    },
    price: {
      type: String
    },
    use_saved_card: {
      type: Boolean
    },
    card_info: {
      type: String
    }
  },
  name: 'PaymentPopup',
  components: {
    StripeVueCard
  },
  mounted () {
    this.localPrice = parseFloat(this.price).toFixed(2)
    if (!this.use_saved_card) {
      this.getPaymentIntent()
    }
  },
  data () {
    return {
      pi_secret: null,
      seti: null,
      pi: null,
      localPrice: 0,
      check: false,
      loading: false,
      payment_completed: false,
      showCard: false
    }
  },
  computed: {
  },
  methods: {
    getPaymentIntent () {
      const payload = {
        amount: this.localPrice * 100,
        save_card: this.check,
        use_saved_card: this.use_saved_card
      }
      this.loading = true
      this.$store.dispatch('getPaymentIntent', payload)
        .then((response) => {
          console.log(response)
          this.pi_secret = response.data.data
          this.pi = response.data.pi
          this.handleStripeIntent()
          this.loading = false
        })
        .catch((e) => {
          console.log(e)
          this.loading = false
        })

    },
    handleStripeIntent () {
      switch (this.pi.status) {
      case 'requires_action':
      case 'requires_source_action':
      case 'requires_payment_method':
      case 'requires_source':
        this.showCard = true
        break
      case 'succeeded':
        this.showCard = false
        this.payment_completed = true
        break
      }
    },
    handleFocus () {
      // do something here
      console.log('in')
      this.cancel()
    },
    handleFocusOut () {
      // do something here
      console.log('out')
    },
    pay_with_saved () {
      this.getPaymentIntent()
    },
    confirm_payment_complete () {
      this.updated(this.pi)
    },
    confirm () {
      this.$vs.loading()

      this.$refs.paymentBridge.setup((response) => {
        console.log('stripe token and amount', response)
        if (response.error) {
          this.$vs.loading.close()
          console.log('failed payment')
        } else {
          const stripe_result = response.setupIntent
          if (stripe_result.status === 'succeeded') {
            this.payment_success = true
            this.$vs.notify({
              title: 'Success',
              text: 'Payment Successful',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })

            const payload = {
              payment_method: stripe_result.payment_method,
              is_default: this.check
            }
            this.$store.dispatch('saveCard', payload)
              .then((response) => {
                console.log('success save_card', response)
                this.updated(stripe_result)
                this.$vs.loading.close()
              })
              .catch((e) => {
                console.log(e)
                this.updated(stripe_result)
                this.$vs.notify({
                  title: 'Failed',
                  text: 'Save Card Failed',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert'
                })

                this.$vs.loading.close()
              })
          } else {
            this.$vs.notify({
              title: 'Failed',
              text: 'Payment Failed',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert'
            })

            this.$vs.loading.close()
            console.log('failed payment')
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">

.form-agreement{
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size:11px;
  margin: 10px 0;

  input {
    width:25px;
    height:25px;
    margin-bottom:0;
  }
  a {
    color:#f08028;
  }
}
.agreement-desc {
  font-size: 12px;
  color:#8C8C82;
}
.popup-row {
  padding: 10px;
  align-items: center;

  span {
    padding: 0 10px;
  }
}
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}
.popup-background {
  width: 400px;
  padding: 20px;
  background: white;
  border: 1px solid #555555;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 25%);
}
.popup-button {
  padding: 10px 20px;
  color: white;
  display: inline-block;
  border-radius: 7px;
  cursor:pointer;
  margin-right:15px;


  &.positive {
    background: #f08028;
  }
  &.negative {
    background: #f3f3f3;
    color: #555555;
  }
}
</style>
